import { useState } from "react";
import BannerSection from "../Component/BannerSection";
import AddressCart from "../Component/Checkout/AddressCart";
import CheckoutOrderBox from "../Component/CheckoutOrderBox";
import Layout from "../Component/Layout/Layout";

export default function Checkout() {
  const [submit, setSubmit] = useState(false);

  return (
    <Layout>
      <BannerSection title="Home" description="Checkout" heading="Check Out" />
      <section class="cart_view mt_100 xs_mt_70 mb_100 xs_mb_70">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-12">
              <AddressCart
                submit={submit}
                setSubmit={setSubmit}
              />
            </div>

            <div className="col-md-4 col-12">
              <CheckoutOrderBox setSubmit={setSubmit} />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
